import { useTranslation } from 'react-i18next';

export function PortalUiSrOnlyInputRequired() {
  const { t } = useTranslation('shared');
  return <span className="sr-only">{t('aria_label.required')}</span>;
}

export default PortalUiSrOnlyInputRequired;
